enum ActionTypes {
  TRACK = "acko/track",
  GTM = "acko/GTM",
  TRACK_BIKE = "acko/track_bike"
}

export default ActionTypes;
